/**
 * Filter management module
 * Handles filter removal and clearing for list views
 */

/**
 * Remove a single filter by key
 * @param {string} filterKey - The query parameter key to remove
 */
export function removeFilter(filterKey) {
    const url = new URL(window.location);
    url.searchParams.delete(filterKey);

    // Handle checkbox filters by unchecking them
    const checkbox = document.querySelector(`input[type="checkbox"][name="${CSS.escape(filterKey)}"]`);
    if (checkbox) {
        checkbox.checked = false;
    }

    // If HTMX is available, use it for seamless updates
    if (typeof htmx !== 'undefined') {
        const target = document.querySelector('[id$="-list-container"]');
        if (target) {
            // htmx expects a selector; a bare id resolved to nothing (targetError)
            htmx.ajax('GET', url.pathname + url.search, { target: '#' + target.id });
            window.history.pushState({}, '', url);
            return;
        }
    }

    // Fallback: full page navigation
    window.location.href = url.href;
}

/**
 * Clear all filters and return to base path
 */
export function clearAllFilters() {
    const url = new URL(window.location);
    window.location.href = url.pathname;
}

/**
 * Initialize filter event delegation
 */
export function init() {
    document.addEventListener('click', function (e) {
        const removeBtn = e.target.closest('[data-remove-filter]');
        if (removeBtn) {
            e.preventDefault();
            removeFilter(removeBtn.dataset.removeFilter);
            return;
        }

        const clearBtn = e.target.closest('[data-clear-filters]');
        if (clearBtn) {
            e.preventDefault();
            clearAllFilters();
        }
    });
}

// Expose globally for backward compatibility with inline onclick handlers
window.removeFilter = removeFilter;
window.clearAllFilters = clearAllFilters;
